import * as React from 'react';
import { Link, useNavigate } from 'react-router';
import { TSubcategory } from './Subcategory.types';
import './Subcategory.styled.scss';

export const Subcategory: TSubcategory = ({
  subcategories,
  categoryId,
  onCategoryClick,
}) => {
  const navigate = useNavigate();

  if (!subcategories || subcategories.length === 0) {
    return null;
  }

  const handleSubcategoryClick = (
    e: React.MouseEvent,
    subcategoryId: string
  ) => {
    e.preventDefault();
    if (categoryId) {
      navigate(`${subcategoryId}`);
      onCategoryClick?.();
    }
  };

  return (
    <div className="subcategory">
      <div className="subcategory__content">
        {subcategories.map((subcategory) => {
          return (
            <Link
              key={subcategory.id}
              to={`${categoryId}`}
              className="subcategory__item"
              onClick={(e) => handleSubcategoryClick(e, subcategory.id)}
            >
              {subcategory.displayName}
            </Link>
          );
        })}
      </div>
    </div>
  );
};
